// extracted by mini-css-extract-plugin
export default {"wrapper":"DataTable_wrapper__BUVky","inputWrapper":"DataTable_inputWrapper__ivnbO","inputContainer":"DataTable_inputContainer__OrDV5"};